module.exports = __webpack_public_path__ + "static/img/group.2a3e0d69.svg";